module.exports = __webpack_public_path__ + "img/9788970138909.09a46575.jpg";